import { formatCurrency, formatDate } from '../../shared/models';
import { StatusBadge as Badge } from '../../shared/ui';
import { displayOrderNumber } from '../earnings/useDeliveredOrders';

// Mirrors iOS DeliveryHistoryRow: order # + status badge, restaurant name,
// item count; payout + date on the right.
export default function DeliveryHistoryCard({ order }) {
  const itemCount = order.orderItems?.length || 0;
  return (
    <div className="flex items-center gap-3 bg-white rounded-2xl shadow-sm border border-gray-100 p-3 w-full text-left">
      <div className="flex-1 min-w-0 space-y-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold text-gray-900 truncate">
            Order #{displayOrderNumber(order)}
          </span>
          <Badge status={order.status} />
        </div>
        <p className="text-xs text-gray-500 truncate">
          {order.restaurantName || 'Restaurant'}
          {order.customerName ? ` → ${order.customerName}` : ''}
        </p>
        {itemCount > 0 && (
          <p className="text-[11px] text-gray-400">
            {itemCount} item{itemCount > 1 ? 's' : ''}
          </p>
        )}
      </div>
      <div className="text-right shrink-0 space-y-0.5">
        <p className="text-sm font-semibold text-gray-900">{formatCurrency(order.driverPayout)}</p>
        <p className="text-[11px] text-gray-400">{formatDate(order.date)}</p>
      </div>
    </div>
  );
}
